'use client';

const getIconSize = ({ size }) => {
  const sizes = {
    xs: "sm",
    sm: "md",
    md: "md",
    lg: "lg"
  };
  return sizes[size];
};
export {
  getIconSize
};
